import React from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from '../../DataTable/datatable.component';
import { Nav } from 'react-bootstrap';
import CommonConfigPage from './CommonConfigPage';
import QIRStatusEditDialog from './Dialogs/QIRStatusEditDialog';
import { useQirStatus } from '../../../hooks/useQIRStatus';
import SelectFilter from '../../DataTable/datatable.selectfilter';

function QIRStatusTable({ onRowClick, refresh }) {

    const { qirStatusList, loading } = useQirStatus(refresh);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'fuzzyText',
            Cell: (props) => {
                return <Nav><Nav.Link onClick={() => { onRowClick(props.row.original); }}>{props.value}</Nav.Link></Nav>
            }
        },
        {
            Header: 'State',
            accessor: 'stateName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Site',
            accessor: 'siteName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Display',
            accessor: 'display',
            filter: 'fuzzyText'
        },
        {
            Header: 'Translation Key',
            accessor: 'translationKey',
            filter: 'fuzzyText'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return <DataTable id="QIRSTatus" tableColumns={tableColumns} tableData={qirStatusList} />
}

function QIRStatusConfiguration() {
    const getNewQIRStatus = () => {
        return { id: null, name: "", stateId: null, businessUnitId: null }
    };

    return (
        <CommonConfigPage
            title="QIR Status"
            table={(showEditDialog, refreshList) => <QIRStatusTable onRowClick={showEditDialog} refresh={refreshList} />}
            dialog={(dialogData, setDialogData, showDialog, closeDialog) => <QIRStatusEditDialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} />}
            getNewConfigObject={getNewQIRStatus}
        />
    );
}

export default QIRStatusConfiguration;